import type { ReduxApplicationState } from '../combinedReducer';

export const selectProductReviews = (state: ReduxApplicationState) => state.reviews;

// The three summary selectors have no consumers yet by design: they are the
// data layer's read API for the ReviewsSummary component (DISC-4326).
export const selectAiSummary = (state: ReduxApplicationState) => state.reviews.aiSummary;

export const selectProductInsights = (state: ReduxApplicationState) =>
  state.reviews.productInsights;

export const selectRatingBreakdown = (state: ReduxApplicationState) =>
  state.reviews.ratingBreakdown;
